import React from 'react';

export interface CardActionsProps {
  children: React.ReactNode;
  border?: boolean;
  justify?: 'start' | 'center' | 'end' | 'between';
  className?: string;
}

const CardActions: React.FC<CardActionsProps> = ({
  children,
  border = false,
  justify = 'end',
  className = '',
}) => {
  const justifyClasses = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between',
  };

  return (
    <div
      className={`flex items-center gap-3 ${justifyClasses[justify]} ${border ? 'border-t border-gray-200 pt-4 mt-6' : 'mt-4'} ${className}`}
    >
      {children}
    </div>
  );
};

export default CardActions;
